"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgIModelLoader = void 0;
const React = __importStar(require("react"));
const SvgIModelLoader = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 740 854.43', ...props },
        React.createElement("style", null, '@keyframes iui-blink{0%,to{opacity:.3}33%{opacity:1}}'),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.17s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M369.99 0v213.61l-92.5-53.4-92.49-53.4L369.94.03l.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.11s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M370 0v213.61l92.5-53.4 92.49-53.4L370.05.03 370 0z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.28s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M185 106.81v213.61l-92.5-53.4-92.49-53.4 184.94-106.78.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.22s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M185 106.81v213.61l92.5-53.4 92.49-53.4-184.94-106.78-.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.33s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M0 213.62v213.61l92.5-53.4 92.49-53.4L.05 213.65l-.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.44s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M0 427.21v213.62l92.5-53.41 92.49-53.4L.05 427.25l-.05-.04z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.16s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M370 213.62v213.61l-92.5-53.4-92.49-53.4 184.94-106.78.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -1s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M370 213.62v213.61l92.5-53.4 92.49-53.4-184.94-106.78-.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.39s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M185.01 320.42v213.61l-92.5-53.4-92.49-53.4 184.94-106.78.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.33s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M185.01 320.42v213.61l92.5-53.4 92.49-53.4-184.94-106.78-.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.5s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M370 427.21v213.62l-92.5-53.41-92.49-53.4 184.94-106.77.05-.04z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.67s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M370 427.21v213.62l92.5-53.41 92.49-53.4-184.94-106.77-.05-.04z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.5s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M185 534.01v213.62l-92.5-53.4-92.49-53.4 184.94-106.79.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.56s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M185 534.01v213.62l92.5-53.4 92.49-53.4-184.94-106.79-.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.72s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M555 534.01v213.62l-92.5-53.4-92.49-53.4 184.94-106.79.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.78s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M555 534.01v213.62l92.5-53.4 92.49-53.4-184.94-106.79-.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.61s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M370 640.82v213.6l-92.5-53.4-92.49-53.39 184.94-106.78.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.67s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M370 640.82v213.6l92.5-53.4 92.49-53.39-184.94-106.78-.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.83s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M555 320.42v213.61l-92.5-53.4-92.49-53.4 184.94-106.78.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.89s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M555 320.42v213.61l92.5-53.4 92.49-53.4-184.94-106.78-.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.94s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M740 213.62v213.61l-92.5-53.4-92.49-53.4 184.94-106.78.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.83s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M740 427.21v213.62l-92.5-53.41-92.49-53.4 184.94-106.77.05-.04z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -.05s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M555 106.81v213.61l-92.5-53.4-92.49-53.4 184.94-106.78.05-.03z' }),
        React.createElement("path", { style: {
                animation: 'iui-blink 1s -1s infinite',
            }, fill: 'var(--iui-color-icon-positive, hsl(118 74% 35%))', d: 'M555 106.81v213.61l92.5-53.4 92.49-53.4-184.94-106.78-.05-.03z' }),
        React.createElement("path", { fill: 'var(--iui-color-white, white)', d: 'M370 131.93a59.58 59.58 0 11-59.58 59.57A59.58 59.58 0 01370 131.93zM538.21 647.2a14 14 0 01-6.84 12l-152.8 91a14 14 0 01-14.29 0l-155.6-91.88a14 14 0 01-6.89-12.07v-80.73a14 14 0 0114-14 13.84 13.84 0 017.16 2l91 50.38V411.52l-49.22-31.36a14 14 0 01-6.85-12.05V287a14 14 0 0121.21-12l140.18 77.56a14 14 0 016.82 12v239.3l91-50.38a13.84 13.84 0 017.16-2 14 14 0 0114 14z' })));
};
exports.SvgIModelLoader = SvgIModelLoader;
exports.default = exports.SvgIModelLoader;
